<template>
  <div v-if="datum" class="popup-content">
    <div class="popup-wrapper">
      <div class="content-box">
        <div>
          <h5 class="data-title">{{ datum.name }}</h5>
        </div>
      </div>
    </div>

    <div class="close-container">
      <i class="icon-closethin" @click="$emit('close')" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['datum'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

@keyframes fadeInLeft {
  from {
    transform: translateX(-12px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes grow {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes growLeft {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.popup-content {
  width: auto;
  white-space: nowrap;
  position: absolute;
  top: -16px;
  padding-right: 36px !important;
}

.popup-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}

.content-box {
  flex: 1;
  overflow: hidden;
  margin-left: -15px;
  padding-left: 15px;

  .data-title {
    font-size: 14px;
    color: #262631;
    margin: 0 0 0.3em;
    font-weight: 900;
    opacity: 0;
    transform: translateX(-12px);
    animation: fadeInLeft ease 0.5s forwards;
    animation-delay: 0.3s;
  }
}

.close-container {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0.8em 0.5em;
  opacity: 0;
  transform: translateZ(0);
  animation: fadein ease 0.3s forwards;
  animation-delay: 0.9s;

  i {
    cursor: pointer;
    color: #000;
    font-size: 1.875em;
    transition: color 0.3s ease;

    &:hover {
      color: colors.$red-active-color;
    }
  }
}
</style>
